<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="2" class="py-2">
                <span><b>Mammals</b></span>
              </b-col>
              <b-col cols="12" md="7" class="py-2">
                
              </b-col>
              

                <b-col cols="12" md="3" class="py-2">
                <b-form @submit.prevent="getSearch">
                  <b-row>
                    <b-col cols="12">
                      <b-form-input
                        
                        v-model="searchKey"
                        placeholder="Search"
                        size="sm"
                      ></b-form-input> 
                      <!-- <datalist id="searchData"> list="searchData"
                        <option v-for="(item,i) in searchData" :key="i">{{item}}</option>
                      </datalist> -->
                    </b-col>
                    <!-- <b-col cols="4">
                      <b-button variant="outline-primary" size="sm" @click="getSearch">Search</b-button>
                    </b-col> -->
                  </b-row>
                </b-form>
              </b-col>
              
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="incidents"
            :fields="fields"
            @row-clicked="rowClicked"
          >
            <template slot="commmonname" slot-scope="data">
              <div class="text-center">
                <span v-if="data.item.commonname">{{data.item.commonname}}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="localname" slot-scope="data">
              <div class="text-center">
                <span v-if="data.item.localname">{{data.item.localname}}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="family" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.family">{{data.item.family}}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="latinname" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.latinname">{{data.item.latinname}}</span>
                <span v-else>-</span>
              </div>
            </template>
            
            <template slot="habitat" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.habitat">{{data.item.habitat}}</span>
                <span v-else>-</span>
              </div>
            </template>
            <template slot="status" slot-scope="data">
              <div class="text-left">
                <span v-if="data.item.mammalstatus">{{data.item.mammalstatus}}</span>
                <span v-else>-</span>
              </div>
            </template>
           
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalIncidents"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextPage"
            />
          </nav>
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data: () => {
    return {
      incidents: [],
      fields: [
        // { key: "caseid", label: "Case ID", sortable: false },
        // { key: "createddate", label: "Created On", sortable: false },
        { key: "commonname", label: "Common Name", sortable: false, align: "center" },
        { key: "localname", label: "Local Name", sortable: false },
        { key: "family", label: "Family", sortable: false },
        { key: "latinname", label: "Latin Name", sortable: false },
        { key: "habitat", label: "Habitat", sortable: false },

        { key: "status", label: "Mammal Status", sortable: false },
        
       
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      totalIncidents: 0,
      searchKey:null,
    };
  },
  beforeMount() {
    this.getData();
  },
  watch:{
    searchKey:function(){
      this.getSearch();
    }
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getData();
    },
     getSearch() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/mammal/search",
        headers: {
          "token": localStorage.getItem("token"),
        },
        params: {
          count: this.perPage,
          page: this.currentPage,
          key:this.searchKey
        }
      })
        .then((response) => {
          if(this.searchKey == '' || this.searchKey == null)
          {
          this.appLoading = false;
          
           this.getData();
          }
          else{
          this.incidents = response.data.data;
          this.totalIncidents = response.data.count;
          this.appLoading = false;
          }
         
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/mammal/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          count: this.perPage,
          page: this.currentPage
        }
      })
        .then(response => {
          this.incidents = response.data.data;
          this.totalIncidents = response.data.count;
          this.appLoading = false;
        })
        .catch(e => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    rowClicked(item) {
      this.$router.push("/Mammals/" + item._id);
    }
  }
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
